import {
  Button, Table, Tag, Typography
} from "antd";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import dayjs from "dayjs";
import { CheckCircleOutlined, EyeOutlined, SyncOutlined } from "@ant-design/icons";
import classes from "./invoiceHistory.module.css";

const { Text } = Typography;

const InvoiceHistory = (props: { size: number, invoiceData: {
  date: string;
  file: string;
  price: string;
  dateOfIssuing: string;
}[] }) => {
  const { size, invoiceData } = props;
  const { t } = useTranslation();

  const data = useMemo(() => {
    return invoiceData.map(invoice => ({
      key: invoice.dateOfIssuing,
      date: invoice.date,
      amount: invoice.price,
      status: invoice.file,
      dateOfIssuing: invoice.dateOfIssuing,
      file: invoice.file
    }));
  }, [invoiceData]);

  const dataColumns = [
    {
      dataIndex: "date",
      render: (date: string) => (date ? <Text type="secondary">{dayjs(date).format("DD MMM YYYY")}</Text> : "-")
    },
    {
      dataIndex: "file",
      render: (file: string) => (file ? (
        <Button
          type="link"
          href={file}
          target="_blank"
          size="small"
          icon={<EyeOutlined style={{ color: "black", opacity: ".45" }} />}
        />
      ) : "-")
    },
    {
      dataIndex: "amount",
      render: (amount: string) => (amount ? <Text type="secondary">{`${amount}€`}</Text> : "-")
    },
    {
      dataIndex: "status",
      render: (file: string) => (file ? (
        <Tag icon={<CheckCircleOutlined />} color="success">
          Pagata
        </Tag>
      ) : (
        <Tag icon={<SyncOutlined spin />} color="warning">
          Ricevuta
        </Tag>
      ))
    },
    {
      dataIndex: "dateOfIssuing",
      render: (dateOfIssuing: string) => <Text type="secondary">{`Visita del ${dayjs(dateOfIssuing).format("DD MMMM YYYY")}`}</Text>
    }
  ];

  return (
    <Table
      showHeader={false}
      pagination={{
        pageSize: size,
        itemRender: () => null,
      }}
      locale={{ emptyText: t("settingsPage.payment.noData") }}
      columns={dataColumns}
      dataSource={data}
      className={classes.root}
    />
  );
};

export default InvoiceHistory;
